import { render, staticRenderFns } from "./MachinesGroups.vue?vue&type=template&id=8a787dc2&"
import script from "./MachinesGroups.vue?vue&type=script&lang=js&"
export * from "./MachinesGroups.vue?vue&type=script&lang=js&"
import style0 from "./MachinesGroups.vue?vue&type=style&index=0&id=8a787dc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports